import { GetStaticPropsContext } from 'next'
import Head from 'next/head'
import { Layout } from '~/components/Layout'
import { Impression, ImpressionStory, fetchImpression } from '~/features/impressions'

type Props = {
  story: ImpressionStory
}

export default function ImpressionPage({ story }: Props) {
  // story = useStoryblok(story, true)

  return (
    <Layout>
      <Head>
        <meta property="og:url" content={`https://digital.next-step.li/`} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="12. Berufs- & Bildungstage 2026 | 25./26. September 2026 | Next-Step – Bildung. Beruf. Liechtenstein"
        />
        <meta property="og:image" content="https://digital.next-step.li/share.jpg" />
      </Head>
      <Impression story={story} />
    </Layout>
  )
}

export async function getStaticProps({ params, preview = true }: GetStaticPropsContext) {
  const slug = params?.slug ? String(params.slug) : ''
  const impression = await fetchImpression(slug, preview)

  if (!impression) {
    return {
      notFound: true,
    }
  }

  return {
    props: { story: impression },
  }
}

// TODO: Fetch all published pages, see https://github.com/storyblok/react-next-boilerplate/blob/main/pages/%5B...slug%5D.js#L57
export async function getStaticPaths() {
  return {
    paths: [{ params: { slug: '2019' } }],
    fallback: 'blocking',
  }
}
